import React, { useState } from "react";
import { empiTheme } from "./styles/empiTheme";

const faqData = [
  {
    question: "What is EmPi?",
    answer:
      "EmPi helps you adjust food and energy choices based on how you feel today.",
  },
  {
    question: "Do I need to track my cycle?",
    answer: "No. It’s optional, but it can help refine suggestions.",
  },
  {
    question: "Can EmPi give me a diet plan?",
    answer: "No. It focuses on simple daily decisions rather than fixed plans.",
  },
  {
    question: "Is EmPi medical advice?",
    answer:
      "EmPi can support everyday reflection around food, movement, energy, and routine. For health concerns, symptoms, treatment decisions, or medical questions, a doctor or qualified healthcare professional is the right person to speak with.",
  },
  {
    question: "What if my day feels off?",
    answer:
      "That’s exactly when EmPi is useful — it helps you adjust instead of forcing a plan.",
  },
  {
    question: "What does EmPi know — and what does it deliberately not know?",
    answer:
      "EmPi works with well-established knowledge about the menstrual cycle, perimenopause, and menopause — the kind that has been confirmed over decades, not published last month. It does not follow new research, does not interpret studies, and does not give medical advice. When a question crosses into medical territory — symptoms, treatments, medications, diagnoses — EmPi tells you directly and points you to a professional. We built it this way on purpose: reliable inside a clear boundary, honest about where the boundary is.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section style={section}>
      <div style={container}>
        <h2 style={title}>Common questions</h2>

        {faqData.map((item, index) => (
          <div key={index} style={faqItem}>
            <button
              type="button"
              onClick={() => toggleItem(index)}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                ...questionButton,
                opacity: hoveredIndex === index ? 0.7 : 1,
              }}>
              <span>{item.question}</span>
              <span style={icon}>{openIndex === index ? "−" : "+"}</span>
            </button>

            {openIndex === index && <p style={answer}>{item.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}

const section = {
  padding: "40px 0 20px",
  background: empiTheme.colors.background,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
  padding: "0 20px",
  display: "grid",
  gap: 8,
};

const title = {
  fontSize: 24,
  fontWeight: 700,
  color: empiTheme.colors.text,
  margin: "0 0 12px",
};

const faqItem = {
  borderBottom: `1px solid ${empiTheme.colors.border}`,
  padding: "14px 0",
};

const questionButton = {
  width: "100%",
  background: "transparent",
  border: "none",
  padding: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  textAlign: "left",
  cursor: "pointer",
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1.4,
  color: empiTheme.colors.text,
  transition: "opacity 0.2s ease",
};

const answer = {
  margin: "12px 0 0",
  fontSize: 15,
  lineHeight: 1.6,
  color: empiTheme.colors.textSecondary,
  maxWidth: 720,
};

const icon = {
  fontSize: 18,
  lineHeight: 1,
  color: empiTheme.colors.textSecondary,
  marginLeft: 12,
};
